import gql from 'graphql-tag';

const EXPORT_REQUESTS_MASTERCARD = gql`
  mutation exportRequestsMastercard($params: ExportCNVRetrievalRequestsInput!) {
    exportCNVRetrievalRequestsMastercard(params: $params) {
      requestFileName
      failedJobsCount
      exportedJobsCount
    }
  }
`;

const EXPORT_REQUEST_ACTIVATION_DEACTIVATION = gql`
  mutation exportTransFlowRequestsMastercard(
    $params: ExportTransFlowRequestsMastercardInput!
  ) {
    exportTransFlowRequestsMastercard(params: $params) {
      requestFileName
      failedJobsCount
      exportedJobsCount
    }
  }
`;

export { EXPORT_REQUESTS_MASTERCARD, EXPORT_REQUEST_ACTIVATION_DEACTIVATION };
